import React, { Component, Fragment } from "react"
import { Link }             from "react-router-dom"
import { withRouter }       from "react-router"
import shop from "shop/shop"
import { Button, Message,Table,Icon } from "semantic-ui-react"
import CartTotal from "components/Cart/CartTotal"
import queryString from "qs"
import {Checkbox, Col, Form, FormField, Row} from "elemental-react16"
import Price from "components/Price/Price"
import { act } from "react"
import Responsive from "react-responsive"
import htmr from "htmr"

@withRouter
class FooterCheckout extends Component {

  state = {
    agb: false,
    privacy: false,
  }

  componentDidMount() {
    shop.cart.hydrate()
  }


    handleEnquiry = () => {
      shop.cart.setExtra( "is_quotation_request", true )
      this.props.history.push( "../success/" )
    }
  
    handleSubmit = async () => {
  
      shop.cart.setExtra( "is_quotation_request", false )
      let couponsActivated = shop.cart.activeCoupons && shop.cart.activeCoupons[0]
      if(couponsActivated){
        await shop.cart.setExtra( "couponUsed", true )
        await shop.cart.setExtra( "netto", Number((shop.cart.brutto) - Number(shop.cart.tax)) )
        await shop.cart.setExtra( "tax", shop.cart.tax )
        await shop.cart.setExtra( "brutto", shop.cart.brutto )
      }
      this.props.history.push( "../success/" )
    }
  
    handleAgb = ( agb ) => {
      console.log( `agb`, agb )
      this.setState( {agb} )
    }
  
    handleDatenschutz( privacy ) {
      this.setState( {privacy} )
    }

	render() {
		const { isRequest, activeStep, order, unavailableProducts} = this.props
    let {agb, privacy,fracht} = this.state
    const canOrder = !agb || shop.cart.sum <= shop.config.MIN_ORDER_VALUE || !privacy
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )

    console.log("WHOAMI FOOTERCHECKOUT: ",activeStep, query, this.props, referer, shop.session ? shop.session.value : "no session")
		//console.log("WHOAMI FOOTERCHECKOUT: ",activeStep, this.props, referer, shop.session ? shop.session.value : "no session")
		return (<React.Fragment>
              <section className="container">
                                    {/*
                                    <div className="cf pb2 pt3">
                                      <Message negative className="" style={{borderRadius: "5px"}}>
                                        <div className="total ">
                                          <div className="ph3">
                                            <Icon name="info" />{translate( "CartDeliverCostHint" )}
                                          </div>
                                        </div>
                                        
                                      </Message>
                                    </div>
                                    */}
                                    { activeStep === 2 && <div className="  cf pb2 pt3 pr3">
                                                  <Message negative className="" style={{borderRadius: "5px"}}>
                                                    <div className="total ">
                                                      <div className="ph3">
                                                        <Icon name="info" />{translate( "Ihr Gesamtpreis kann sich bei der Rechnungserstellung durch Rabatte/ nachgelagerte Kundenkonditionen noch ändern." )}
                                                      </div>
                                                    </div>
                                                    
                                                  </Message>
                                                </div>}
                                    {unavailableProducts && <div className="cf pb2 pt3 pr3">
                                      <Message negative className="" style={{borderRadius: "5px"}}>
                                        <div className="total ">
                                          <div className="ph3">
                                            <Icon name="info" />{translate( "Bitte beachten Sie, dass die von uns in rot markierten Artikel erst zu einem späteren Zeitpunkt lieferbar sind." )}
                                          </div>
                                        </div>
                                        
                                      </Message>
                                    </div>}
                </section>
                <section className="container">
                                    {shop.cart.sum <= shop.config.MIN_ORDER_VALUE && activeStep <= 2 &&
                              <div className="cf pb2 pt3 pr3">
                                <Message negative className=""  style={{borderRadius: "5px"}}>
                                  <div className="total ">
                                    <div className="ph3">
                                      <Icon name="info" />{translate( "minimum order value not reached" )}
                                      <span className="pull-right">
                                                  <Price>{shop.config.MIN_ORDER_VALUE}</Price>
                                       </span>
                                    </div>
                                  </div>
                                  
                                </Message>
                              </div>
                              }
                </section>
              <section>

          <div className={`${activeStep !== 3 ?  "container pt4" : "pt4"}`}>
                      <div className="">
                        <div className="">
                          {activeStep !== 3 && activeStep !== 10 ? <CartTotal activeStep={activeStep} sum={shop.cart.sum} size={shop.cart.size}/> : activeStep == 10 ? <CartTotal activeStep={activeStep} sum={Number(order.netto)} size={order.positions.length}/> : <CartTotal activeStep={activeStep} sum={Number(order.netto)} size={order.positions.length}/>}
                        </div>
                      </div>
            </div>
            {activeStep == 2 && <div className="container pt3">
              <div className="tr pr2">
                              <Form type="horizontal">

                  <FormField>

                    {!privacy && <div className="cf dib">
                      <Message negative className="" style={{borderRadius: "5px", height: "40px", alignItems: "center", display: "flex"}}>
                        <div className="total ">
                          <div className="">
                            <Icon name="info" />{translate( "please confirm our privacy information" )}
                          </div>
                        </div>
                      </Message>
                    </div>}

                    <div className="tr pt2"><Link target="_blank"
                                  to="/cms/datenschutzerklaerung/">{translate( "Datenschutzerklärung" )}</Link><br />
                    </div>
                    <Checkbox value={privacy}
                          onChange={( e ) => this.handleDatenschutz( e.target.checked )}
                          label={translate( "privacy_notice_notice" )} />
                  </FormField>



                  <FormField>
                    {!agb && <div className="cf dib">
                      <Message negative className="" style={{borderRadius: "5px", height: "40px", alignItems: "center", display: "flex"  }}>
                        <div className="total">
                          <div className="">
                            <Icon name="info" />{translate( "please confirm our general terms" )}
                          </div>
                        </div>
                      </Message>
                    </div>}

                    <div className="tr pt2"><Link target="_blank"
                                  to="/cms/agb/">{translate( "AGB" )}</Link><br /></div>
                    <Checkbox value={agb} onChange={( e ) => this.handleAgb( e.target.checked )}
                          label={translate( "I accept the general terms and conditions" )} />
                  </FormField>
                </Form>
            </div>
            </div>}
        </section>
      <Responsive minWidth={768}>
        <section className="mb4 pt3">
          <div className={`${activeStep !== 3 ?  "container" : ""}`}>
            <div className="footerCheckoutBottom">
              <div className="flex flex-column justify-start items-start">
                <div className="" >
                  <Link className={"logo"} to="/home/">
                    <img  style={{ width: "440px"}}
                      src={"/image/03_Wortmarke/Wortmarke_raeder_schwarz.png"}
                      alt="" />
                  </Link>
                </div>
                <p className="pl2 f5 cssLindtGrey">{htmr(translate("<b className=\" f4 cssOptima\">Persönliche Beratung oder Display-Bestellung gewünscht?</b><br/>Profitieren Sie von einer persönlichen Beratung unserer<br/> Ansprechpartner rund um Ihr individuelles Anliegen."))}</p>
                <div className="flex flex-row justify-between">
                  <div className="pl2 pr2"><a href={`tel:+492418881345`}><span className="f5 fw5" style={{ color: "#917236", backgroundColor: "transparent" }}><Icon
                                                  name={"phone"} />+49 241 8881 345</span></a></div> |
                  <div className="pl2"><a href={`mailto:customer-sales-de@lindt.com?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session ? shop.session.value.map_id : ""}`}>
                                          <span className="f5 fw5" style={{ color: "#917236", backgroundColor: "transparent" }}><Icon
                                        name={"mail"} />customer-sales-de@lindt.com</span></a></div>

                </div>
                  <Button as={Link} to="/customer_contact" primary id="HeaderButtonV3"
                    onClick={() => { this.setState({ index: false, hover: false }); }}
                    style={{ marginLeft: "8px", marginTop: "20px", height: "50px", width: "250px" }} className="ml3 pl3">
                    <p className="u fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                      {translate("Kontaktformular öffnen")}
                    </p>
                  </Button>
              </div>
              <div className="flex flex-column justify-between items-end">
                                            { activeStep <= 2 && <Fragment><div className="">
                              <Link to={{
                                  pathname: activeStep === 0 ? "/checkout/delivery"  : activeStep === 1 ? "/checkout/confirmation" : undefined,
                                  search  : this.props.location.search
                                }}>
                                  <Button onClick={() => {
                                    if(activeStep === 2) {
                                      this.handleSubmit()
                                    }
                                  }}
                                    loading={false} disabled={activeStep == 2 ? canOrder : false}
                                    primary style={{borderRadius: "5px", height: "40px", width: "240px"}} className="ml3 pl3">
                                    {activeStep === 0 || activeStep === 1 ? translate( "Weiter" ) : translate( "Bestellung abschicken" )}
                                    <i className="icon-angle-right"/>
                                  </Button>
                                </Link></div></Fragment>}
                                {activeStep === 100 && <Fragment>
                                  {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus" ? "" :
                                    <div className="pb2"><Link to="/"> <Button style={{width: "200px", borderRadius: "0px", height: "40px"}} basic> <i className="icon-angle-left"  />{translate( "zurück zur Startseite" )}</Button></Link></div>}
                                  <div className="pt2"><Link to="/checkout"> <Button style={{width: "200px", borderRadius: "0px", height: "40px"}} primary>{translate( "zum Warenkorb" )}<i className="icon-angle-right" /> </Button></Link></div>
                                </Fragment>}
                                {activeStep === 0 && <div className="pt2">
                                <Link className={""} to={query.referrer}>
                                <Button style={{borderRadius: "0px", height: "40px", width: "240px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link></div>}
                              {activeStep != 0 && activeStep !== 10 && activeStep !== 100 && <div className="pt2"><Link className={""} to={{
                                  pathname: activeStep === 0 ? query.referrer  : activeStep === 1 ? "/checkout" : activeStep == 2 ? "/checkout/delivery" : activeStep == 3 ? "/home" : undefined,
                                  search  : this.props.location.search
                                }}>
                                <Button  style={{borderRadius: "0px", height: "40px", width: "240px"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link></div>}
              </div>
            </div>

              </div>
          {activeStep == 3 && <div className="">
          {/*<p className="b pt3 pl2"> {translate( "confirmation.notice" )}</p> */}
          {/*<p>{translate("Der Gesamtpreis netto kann sich bei der Rechnungsstellung durch Lieferkosten noch ändern.")}</p> */}
        </div>}
        </section>
        </Responsive>
      <Responsive maxWidth={767}><div className="pt4">
                        <div className="flex flex-row items-center justify-center pl2 pr2">
                          <table>
                          <tbody>
                            { activeStep <= 2 && <Fragment><tr>
                              <td className="pt4 pb3">
                              <Link to={{
                                  pathname: activeStep === 0 ? "/checkout/delivery"  : activeStep === 1 ? "/checkout/confirmation" : undefined,
                                  search  : this.props.location.search
                                }}>
                                  <Button onClick={() => {
                                    if(activeStep === 2) {
                                      this.handleSubmit()
                                    }
                                  }}
                                    loading={false} disabled={activeStep == 2 ? canOrder : false}
                                    primary style={{borderRadius: "5px", height: "40px", width: "100%"}} className="ml3 pl3">
                                    {activeStep === 0 || activeStep === 1 ? translate( "Weiter" ) : translate( "Bestellung abschicken" )}
                                    <i className="icon-angle-right"/>
                                  </Button>
                                </Link>
                              </td>
                            </tr></Fragment>}
                            <tr>
                              <td>
                                {activeStep === 100 && <Fragment>
                                {shop.config && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus" ? "" : <Link to="/"> <Button style={{width: "200px", borderRadius: "5px", height: "40px"}} basic> <i className="icon-angle-left"  />{translate( "zurück zur Startseite" )}</Button></Link>}  
                                  <Link to="/checkout"> <Button style={{width: "100%", borderRadius: "5px", height: "40px"}} primary>{translate( "zum Warenkorb" )}<i className="icon-angle-right" /> </Button></Link>
                                </Fragment>}
                                {activeStep === 0 && 
                                <Link className={""} to={query.referrer}>
                                <Button style={{borderRadius: "5px", height: "40px", width: "100%"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>}
                              {activeStep != 0 && activeStep !== 10 && activeStep !== 100 && <Link className={""} to={{
                                  pathname: activeStep === 0 ? query.referrer  : activeStep === 1 ? "/checkout" : activeStep == 2 ? "/checkout/delivery" : activeStep == 3 ? "/home" : undefined,
                                  search  : this.props.location.search
                                }}>
                                <Button style={{borderRadius: "5px", height: "40px", width: "100%"}} className="ml3 pl3">
                                  <i className="icon-angle-left"/>
                                  {translate( "Zurück" )}
                                </Button>
                              </Link>}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                          </div>
                          <div className="pl2 mt4 flex flex-column items-center">
                            <table className="">
                            <colgroup>
                                <col width="30%"/>
                                <col width="70%"/>
                              </colgroup>
                                  <tbody>
                                    <tr>
                                      <td colSpan="2" className="">
                                        <div className="pb3" >
                                          <Link className={"logo"} to="/home/">
                                            <img  style={{ width: "440px"}}
                                              src={"/image/03_Wortmarke/Wortmarke_raeder_schwarz.png"}
                                              alt="" />
                                          </Link>
                                          </div>
                                      <p className="f5 fw7 pl2 pr2 tc">{activeStep == 10 ? translate("Sie haben Fragen zu Ihrer Bestellung?"): translate("cartfooter.helphint")}</p>
                                      </td>
                                      </tr>
                                    <tr>
                                      <td className="pt3 tc">
                                        <a href={`tel:+492418881345`}><span className="f6 fw5" style={{ color: "#D4AF37", backgroundColor: "transparent" }}><Icon
                                                  name={"phone"} />+49 241 8881 345</span></a>
                                        </td>
                                      <td className="pt3 tc">
                                        <a href={`mailto:customer-sales-de@lindt.com?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session ? shop.session.value.map_id : ""}`}>
                                          <span className="f6 fw5" style={{ color: "#D4AF37", backgroundColor: "transparent" }}><Icon
                                        name={"mail"} />customer-sales-de@lindt.com</span></a>
                                      </td>
                                    </tr>
                                  </tbody>
                          </table>
                          </div>
                          </div>

        </Responsive>

        </React.Fragment>
		)
	}
}

export default FooterCheckout



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/pages/checkout/FooterCheckout.js